import { render, staticRenderFns } from "./right_4.vue?vue&type=template&id=19f96fd6&scoped=true&"
import script from "./right_4.vue?vue&type=script&lang=js&"
export * from "./right_4.vue?vue&type=script&lang=js&"
import style0 from "./right_4.vue?vue&type=style&index=0&id=19f96fd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f96fd6",
  null
  
)

export default component.exports